module.exports = __webpack_public_path__ + "img/small-yandex-promo.1c611471.svg";